import { render, staticRenderFns } from "./FilterBrand.vue?vue&type=template&id=5fddb452&"
import script from "./FilterBrand.vue?vue&type=script&lang=ts&"
export * from "./FilterBrand.vue?vue&type=script&lang=ts&"
import style0 from "./FilterBrand.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports